module.exports = __webpack_public_path__ + "static/img/5.62e2852.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/5.png
// module id = AtCl
// module chunks = 0